import TmpPatients from '../views/TmpPatients.vue'

export const routes = [
  {
    path: '/tmp_patients',
    name: 'TmpPatients',
    component: TmpPatients
  },
]